import React, { Component } from 'react';
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import DataTable from "react-data-table-component";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";


class PatientMedication extends Component {
    constructor(props) {
        super(props);

        this.state = {
            medicationList: [],
            pageNum: null,
            paginationValue: 5,
            isLoading: true,
            selectedTreatmentId: "",
            procedures: [],

        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchEnrolledAdmissions();
            this.fetchMedications();
        }, 500)
    }
    fetchEnrolledAdmissions = () => {
        var thisController = this;
        var serviceLineId = localStorage.getItem("serviceLineId");
        $.ajax({
            url: "/my-jeeva-api/get-patient-admissions",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                patientEmailId: localStorage.getItem("patientEmailId")
            },
            success: function (res) {
                if (res.success === true) {
                    var data = res.result;
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            if(serviceLineId == res.result[i].serviceLineId)
                            thisController.state.procedures.push({
                                name: res.result[i].procedureName,
                                value: res.result[i].procedureId,
                            });
                        }
                        thisController.state.procedures.unshift({ value: "22222222-2222-2222-2222-222222222222", name: "All" });
                        thisController.state.procedures.push({ value: "11111111-1111-1111-1111-111111111111", name: "General Wellness" });
                        thisController.setState(thisController.state);
                        console.log("procedures are : " + thisController.state.procedures);
                    }

                }
            },
        });
    }
    fetchMedications() {
        var thisController = this;
        var treatmentId = thisController.state.selectedTreatmentId;
        if (treatmentId == null || treatmentId == undefined || treatmentId == "") {
            treatmentId = "22222222-2222-2222-2222-222222222222";
        }
        $.ajax({
            url: "/my-jeeva-api/all-medications",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                treatmentId: treatmentId,
                // treatmentId: localStorage.getItem("patientProcedureId"),
                patientId: localStorage.getItem("patientId"),
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.state.medicationList = res.result;
                    thisController.state.isLoading = false;
                    thisController.setState(thisController.state);

                }
            },
        });
    }
    onProcedureChange = (e) => {
        this.state.selectedTreatmentId = e.target.value;
        this.setState(this.state);
        this.fetchMedications();
    }
    fetchAllDaysOfWeek(medicationId) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "/my-jeeva-api/all-schedule-daysOfWeek",
                method: "GET",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                data: {
                    medicationId: medicationId
                },
                success: function (res) {
                    if (res.success === true) {
                        const daysOfWeekList = res.result;
                        if (daysOfWeekList.length > 0) {
                            resolve(daysOfWeekList[0].daysOfWeek);
                        } else {
                            resolve([]);
                        }
                    } else {
                        reject(new Error("Failed to fetch days of week"));
                    }
                },
                error: function (xhr, status, error) {
                    reject(error);
                }
            });
        });
    }

    openDayofWeekPage = (row) => {
        localStorage.setItem("medicationId", row.id);
        localStorage.setItem("medicationTitle", row.name);
    }


    getColoumns() {
        const columns = [
            {
                name: <b style={{ fontSize: "16px"}}>Medication Name</b>,
                selector: (row) => {
                    return (
                        <div className="container-fluid" >
                            {row.name}
                        </div>
                    );
                },
            },
            {
                name: <b style={{ fontSize: "16px",  display: "flex", justifyContent: "center" }}>Medication Unit</b>,
                selector: (row) => (
                    <div className="container-fluid">
                        {row.unitName}
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: '16px' }}>Action</b>,
                width: 36,
                selector: (row) => (
                    <div id="action" style={{paddingLeft:"44%"}}>
                        <Link to="/projectmgmt/reports/days-of-week" onClick={(e) => { this.openDayofWeekPage(row, e) }}>
                            <button className="btn action-button"
                                 title="Days of week">
                                <img className="img-responsive"
                                    src="./assets/images/schedule.png"
                                />
                            </button>
                        </Link>

                    </div>
                ),

            },

        ];
        return columns;
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e });
    };

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no medications present. </p>
        </div>
    );


    render() {
        return (
            <div style={{ margin: "auto"}}>
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                <link rel="stylesheet" href="assets/css/adminlte.css" />
                <link rel="stylesheet" href="assets/css/custom-style.css" />
                <link rel="stylesheet" href="assets/css/styles.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="assets/css/customDataTable.css" />

                <div className="row">
                    <div style={{ marginTop: '16px' , marginLeft:"0.5vw"}}  >
                        <Link to="/projectmgmt/reports/medication-adherence">
                            <img src="./assets/images/arrow.svg"
                                style={{ paddingRight: "30%", cursor: 'pointer' }}
                            />
                        </Link>
                    </div>
                    <div >
                        <h6 className="nav-item" style={{ marginTop: '17px', fontSize: "17px" }}>
                            Medications</h6>

                    </div>
                    <div className="col-sm-4" Align='right'>
                                <label
                                    style={{
                                        marginLeft: "-40vh",
                                        // display:
                                        //     window.SCOPE_VALUE.CURRENT >
                                        //         window.SCOPE_VALUE.SERVICELINE_ADMIN
                                        //         ? "inline"
                                        //         : "none",
                                    }}
                                >
                                    Treatments
                                </label>
                                <select
                                    value={this.state.selectedTreatmentId}
                                    onChange={(e) => this.onProcedureChange(e)}
                                    placeholder="Select treatment"
                                    style={{
                                        // display:
                                        //     window.SCOPE_VALUE.CURRENT >
                                        //         window.SCOPE_VALUE.SERVICELINE_ADMIN
                                        //         ? "inline"
                                        //         : "none",
                                        height: "30px",
                                        borderRadius: "4px",
                                        backgroundColor: "#F9F9FB",
                                        width: "13vw",
                                        marginLeft: "10px",
                                        marginRight: "2vw",
                                        marginTop: "1vh"
                                    }}
                                >
                                    {this.state.procedures.map((procedure) => (
                                        <option value={procedure.value}>
                                            {procedure.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                </div>
                <br />
                <div style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                    {this.state.isLoading && (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                            <p>Loading ...</p>
                        </div>
                    )}
                    {!this.state.isLoading && this.state.medicationList.length == 0 &&(
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                            <p>There are no medications present.</p>
                        </div>
                    )}
                    {this.state.medicationList.length > 0 && (
                        <DataTable
                            columns={this.getColoumns()}
                            data={this.state.medicationList}
                            defaultPageSize={6}
                            pagination={this.state.paginationValue}
                            noDataComponent={<this.CustomNoDataComponent />}
                        />
                    )}
                </div>

            </div>
        );
    }
}

export default PatientMedication;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientMedication.js